import Home from "./Home/Home";
import Footer from "./Footer/Footer";

function App() {
  return (
    <div>
      <Home />
      <Footer />
    </div>
  );
}

export default App;
